<style scoped>
    .helpBox {
        padding-top: .98rem;
        min-height: 100vh;
        background: #fff;

    }
    .f1{
        display: flex;
        align-items: center;
        font-size: .3rem;
        color: #000;
        margin-bottom: .3rem;
    }
    .line{
        width: .05rem;
        height: .3rem;
        background: #00C59F;
        border-radius: .03rem;
        margin-right: .16rem;
    }
    .contentBox{
        padding: .24rem;
    }
    .title{
        font-size: .3rem;
        color: #000;
        margin: .3rem 0;
    }
    .content{
        font-size: .28rem;
        color: #3B3B3B;
        line-height: .42rem;
    }
</style>
<template>
    <div class="helpBox">
        <topbar text="帮助"></topbar>
        <div class="contentBox">
            <div class="f1">
                <div class="line"></div>
                预约服务可设置本周和下一周的可约时间
            </div>
            <div class="title">1.按天设置：按日期设置可约时间</div>
            <div class="content">
                选择一个日期，点击页面下方添加可约时间，进入相应页面设置当前日期的可约时间。设置时，选中一个时间即表示当前的时间可约。设置可约时间可进行修改。如选中[8:00]，即表示服务时间段位[8:00-8:50]，[8:00]系统会发起通话。
            </div>
            <div class="title">2.批量设置：设置每周重复时间</div>
            <div class="content">
                如：选择[周一]，接着选择一个或多个可约时间并保存设置，即未来每个[周一]的可约时间都一次类推。设置时间可进行修改。
            </div>
        </div>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,

            }
        },
        components: {
            noMoreData,
            topbar,
        },
        filters: {

            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {},
        destroyed() {

        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/help.vue